var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-group" }, [
    _c("div", { staticClass: "form-group__newsletter" }, [
      _c(
        "span",
        { staticClass: "visually-hidden", attrs: { id: "subscription-form" } },
        [_vm._v("Subscription Form")]
      ),
      _vm._v(" "),
      _c(
        "input",
        _vm._b(
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.currentValue,
                expression: "currentValue"
              }
            ],
            staticClass: "input",
            class: _vm.stateClasses,
            attrs: {
              type: "email",
              id: _vm.id,
              name: "email",
              "aria-labelledby": "subscription-form",
              disabled: _vm.disabled,
              placeholder: _vm.placeholder,
              required: _vm.required
            },
            domProps: { value: _vm.currentValue },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.currentValue = $event.target.value
              }
            }
          },
          "input",
          _vm.$attrs,
          false
        )
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          class: _vm.buttonClasses,
          attrs: {
            type: "submit",
            "aria-label": "Subscribe",
            disabled: !_vm.buttonIsEnabled
          }
        },
        [
          _c("span", { staticClass: "visually-hidden" }, [_vm._v("Subscribe")]),
          _vm._v(" "),
          _c("icon", {
            attrs: {
              name: "chevron-right-thin",
              size: "14px",
              fill: "transparent",
              stroke: "currentColor"
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }